<div class="con">
    <mat-toolbar class="hidden-lg hidden-md hidden-sm">
      <img src="../../../../assets/img/tecno-cup-ksa/tecno-mobile-logo.png" class="img-responsive text" >
      <img src="../../../../assets/img/tecno-cup-ksa/icon-menu.png"
           class="img-responsive" (click)="toggle()">
    </mat-toolbar>
    <mat-drawer-container class="app-container" autosize>
    <mat-drawer  [mode]="'over'" [opened]="opened" (closed)="opened = false" position="end">
      <div class="drawerCon">
        <div id="sidemenu-wrapper">
          <svg (click)="navigateTo()" xmlns="http://www.w3.org/2000/svg" routerLink="home" viewBox="0 0 134.773 27"><path d="M-32.294,215.122a6.356,6.356,0,0,1,6.334,6.334V242.1H-33.1V222.288a3.547,3.547,0,0,0-3.527-3.527h-8.131v23.316H-51.9V215.122h19.61m29.134,0a6.356,6.356,0,0,1,6.334,6.334v14.308A6.356,6.356,0,0,1-3.161,242.1h-13.3a6.356,6.356,0,0,1-6.334-6.334V221.457a6.356,6.356,0,0,1,6.334-6.334h13.3m-8.94,3.639a3.547,3.547,0,0,0-3.527,3.527v12.646a3.547,3.547,0,0,0,3.527,3.527h4.582a3.547,3.547,0,0,0,3.527-3.527V222.288a3.547,3.547,0,0,0-3.527-3.527Zm-84.054-3.639a6.356,6.356,0,0,0-6.334,6.334v14.308a6.356,6.356,0,0,0,6.334,6.334h15.768v-3.639H-91.8a3.547,3.547,0,0,1-3.527-3.527v-4.807h14.937v-3.639H-91.8a3.547,3.547,0,0,1-3.527-3.527v-.7a3.547,3.547,0,0,1,3.527-3.527h11.411V215.1H-96.155m25.292.022a6.356,6.356,0,0,0-6.334,6.334v14.308a6.356,6.356,0,0,0,6.334,6.334h15.768v-3.639H-66.5a3.547,3.547,0,0,1-3.527-3.527V222.288a3.547,3.547,0,0,1,3.527-3.527h11.411v-3.639H-70.862m-34.794,0H-131.6v3.639h9.389v23.316h7.143V222.265a3.533,3.533,0,0,1,3.527-3.527h5.885Z" transform="translate(131.6 -215.1)" fill="#fff" fill-rule="evenodd"/></svg>
          <div (click)="navigateTo()" class="link" routerLink="./home" routerLinkActive="active">
            <p>{{globalService.customLang.main_page}}</p>
          </div>
          <div (click)="navigateTo()" class="link" routerLink="tournaments" routerLinkActive="active" >
            <p>{{globalService.customLang.tournament}}</p>
          </div>
          <div (click)="navigateTo()" class="link" routerLink="./qualified-player" routerLinkActive="active" >
            <p>{{globalService.customLang.qualified_player}}</p>
          </div>
          <div (click)="navigateTo()" class="link" routerLink="./rules-terms" routerLinkActive="active" >
            <p>{{globalService.customLang.rules_terms}}</p>
          </div>
          <ng-container *ngIf="globalService.langChosen === 'ar'; else english">
            <div class="language-button" (click)="languageChange('en')"
                 [ngClass]="{ArbClass : globalService.langChosen === 'ar'}">
                <img src="assets/img/flags/gb.svg" alt="">
                <p>Eng</p>
            </div>
          </ng-container>
        </div>
      </div>

    </mat-drawer>
  </mat-drawer-container>

    <div class="header-container hidden-xs"  [ngClass]="{engClass : globalService.langChosen === 'en'}">
      <div class="container">
        <div class="flex_block">
          <div id="logo">
            <img routerLink="./home" src="../../../../assets/img/tecno-cup-ksa/tecno-mobile-logo.png" class="img-responsive ">
          </div>

          <div class="menu">
            <div class="item" routerLink="home" routerLinkActive="active">
              <p>{{globalService.customLang.main_page}}</p>
            </div>
            <div class="item" routerLink="tournaments" routerLinkActive="active" >
              <p>{{globalService.customLang.tournament}}</p>
            </div>
            <div class="item" routerLink="./qualified-player" routerLinkActive="active" >
              <p>{{globalService.customLang.qualified_player}}</p>
            </div>
            <div class="item" routerLink="./rules-terms" routerLinkActive="active" >
              <p>{{globalService.customLang.rules_terms}}</p>
            </div>
          </div>
          <ng-container *ngIf="globalService.langChosen=='ar'; else english">
            <div class="language-button" (click)="languageChange('en')">

              <img src="assets/img/flags/gb.svg" alt="">
              <p>Eng</p>
            </div>
          </ng-container>
          <ng-template #english>
            <div class="language-button" (click)="languageChange('ar')">
              <img src="assets/img/flags/sa.svg" alt="">
              <p>عربي</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="tecno-cup-banner2">
      <img src="../../../../assets/img/tecno-cup-ksa/tecno-banner.jpg" class="img-responsive hidden-xs" >
      <img src="../../../../assets/img/tecno-cup-ksa/tecno-banner-mob.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" alt="">
    </div>


  <div class="container">
    <div class="banner_container" style="margin: 20px" >
      <a target="_blank" href="https://www.tecno-mobile.com/iq/phones/product-detail/product/pova-3-5/#/">
        <img class="img-responsive hidden-xs" src="../../../../assets/img/tecno-cup-ksa/tecno-ad.jpg" alt=""  >
        <img src="../../../../assets/img/tecno-cup-ksa/tecno-ad-mob.jpg" class="img-responsive  hidden-lg hidden-md hidden-sm" alt="">
      </a>

    </div>
    <div  [ngClass]="{engClass : globalService.langChosen === 'en'}">
    <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer-reusable [backgroundBody]="'#111111'"></app-footer-reusable>
</div>
